import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { isLicenseNotSet, isSubscriptionLicenseType } from '@core/helpers/license/license.helper';
import { LicenseService } from '@core/services/license/license.service';
import { RoutePath } from '@shared/route-path.enum';
import { map } from 'rxjs';

export const licenseNotSetOrSubscriptionGuard = (_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
	const licenseService = inject(LicenseService);
	const router = inject(Router);

	return licenseService.license$.pipe(
		map((license) => {
			if (
				isLicenseNotSet(license.licenseType, license.licenseStatus) ||
				isSubscriptionLicenseType(license.licenseType)
			) {
				return true;
			}
			router.navigate([RoutePath.NUTRITION]);
			return false;
		})
	);
};
